import { States } from "../App";

function Button({ buttonImg, buttonAlt, clickFunction }) {
  return (
    <div className="floating-button" onClick={clickFunction}>
      <img src={buttonImg} alt={buttonAlt} onClick={clickFunction} />
    </div>
  );
}

export function ChooseSpinnerButton({ setState }) {
  return (
    <Button
      buttonImg="spinner.png"
      buttonAlt="Choose spinner"
      clickFunction={() => {
        setState(States.ChooseSpinner);
      }}
    />
  );
}

export function EditSpinnerButton({ setState }) {
  return (
    <Button
      buttonImg="rulebook2.png"
      buttonAlt="Edit spinner"
      clickFunction={() => {
        setState(States.EditSpinner);
      }}
    />
  );
}

export function AddSpinnerButton({ setState }) {
  return (
    <Button
      buttonImg="plus.png"
      buttonAlt="Add spinner"
      clickFunction={() => {
        setState(States.AddSpinner);
      }}
    />
  );
}

export function HideCheckedEntriesButton({
  hideCheckedEntries,
  setHideCheckedEntries,
}) {
  return (
    <Button
      buttonImg={hideCheckedEntries ? "eye_closed2.png" : "eye_open2.png"}
      buttonAlt={(hideCheckedEntries ? "Show" : "Hide") + " checked entries"}
      clickFunction={() => {
        setHideCheckedEntries(!hideCheckedEntries);
      }}
    />
  );
}

export function CloseButton({ setState }) {
  return (
    <Button
      buttonImg="cross.png"
      buttonAlt="Close"
      clickFunction={() => {
        setState(States.SpinTheWheel);
      }}
    />
  );
}
